"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECartesian2dUserTransform = void 0;
/**
 * @public
 * Supported 2d user transforms.
 */
var ECartesian2dUserTransform;
(function (ECartesian2dUserTransform) {
    ECartesian2dUserTransform[ECartesian2dUserTransform["Identity"] = 0] = "Identity";
    ECartesian2dUserTransform[ECartesian2dUserTransform["NaturalLog"] = 1] = "NaturalLog";
})(ECartesian2dUserTransform = exports.ECartesian2dUserTransform || (exports.ECartesian2dUserTransform = {}));
//# sourceMappingURL=e-cartesian2d-user-transform.js.map